export enum FIELD_NAME {
  email = 'email',
}

export type FormValuesType = {
  [FIELD_NAME.email]: string
}

export interface Props {
  onDiscardClick: () => void;
  onClose: () => void;
  sku: number;
}
